import { Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { useTranslate } from 'react-admin'
import { virtualExpChoices } from 'services/cfg/form'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const PREFIX = 'VirtualExpSpecialTypeInput'

const classes = {
  tooltip: `${PREFIX}-tooltip`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }: any) => ({
  [`& .${classes.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 16,
    border: '1px solid black',
  },
}))

const LightTooltip = Tooltip

const VirtualExpSpecialTypeInput = () => {
  const translate = useTranslate()

  return (
    <Root>
      <LightTooltip
        title={translate('form.fields.virtualExpSpecialTypeTooltip')}
        placement="right-end"
        classes={{
          tooltip: classes.tooltip,
        }}
      >
        <KSelectInput
          required
          source="specialType"
          resettable
          choices={virtualExpChoices}
          style={{ width: '250px' }}
        />
      </LightTooltip>
    </Root>
  )
}

export default VirtualExpSpecialTypeInput
